import { mezoMainnet, mezoTestnet } from "@mezo-org/passport"
import { JsonRpcProvider } from "ethers"
import { mainnet, sepolia } from "viem/chains"

import { MEZO_NETWORK, RPC_URL_ETHEREUM, RPC_URL_MEZO } from "./env"

export const IS_MEZO_MAINNET = MEZO_NETWORK === "mezo"

export const ETHEREUM_CHAIN_ID = IS_MEZO_MAINNET ? mainnet.id : sepolia.id

export const MEZO_CHAIN = IS_MEZO_MAINNET ? mezoMainnet : mezoTestnet

export const MEZO_PROVIDER = new JsonRpcProvider(RPC_URL_MEZO, undefined, {
  batchStallTime: 100,
})

export const ETHEREUM_PROVIDER = new JsonRpcProvider(RPC_URL_ETHEREUM)
